export const isDev = () => {
  if (
    process.env.REACT_APP_STAGE &&
    ['local', 'dev', 'int', 'cons'].includes(process.env.REACT_APP_STAGE)
  ) {
    return true
  }
  return false
}
